<template>
  <router-link class="project-banner" :to="{ path: projectPath }">
    <img :src="imagePath()"></img>
    <h5>{{ project.name }}</h5>
  </router-link>
</template>

<script>
import { imageUrl } from '../utils';

export default {
  name: 'project-banner',
  props: [
    'project'
  ],
  computed: {
    projectPath () {
      return `/project/${this.$props.project.name}`;
    }
  },
  methods: {
    imagePath () {
      return imageUrl(this.$props.project.thumbnail);
    }
  }
}
</script>

<style lang="scss">
@import "../assets/styles/_variables.scss";

.project-banner {
  display: flex;

  width: 100%;

  position: relative;
  align-items: center;
  justify-content: center;
  text-align: center;

  background: $color-dark;
}

.project-banner > img {
  width: 100%;
  height: 100%;

  transition: opacity 300ms;

  opacity: 1;
}

.project-banner:hover > img {
  opacity: 0.3;
}

.project-banner > h5 {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%,-50%);

  color: $color-light;
  line-height: 2rem;

  max-width: 90px;

  transition: opacity 300ms;

  opacity: 0;
}

.project-banner:hover > h5 {
  opacity: 1;
}
</style>




// WEBPACK FOOTER //
// ProjectBanner.vue?843daade